import React from "react";
import "ui/UICarousel.css";

// https://css-tricks.com/css-only-carousel/

const UICarousel = (props) => {
  let items = props.items;
  console.log("carousel", items);
  let carousel = (
    <div
      className="hs full no-scrollbar"
      style={{ margin: "10px", width: "100%" }}
    >
      {items.map((item) => item)}
    </div>
  );

  return carousel;
};

export default React.memo(UICarousel, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
